import { c as _c } from "react/compiler-runtime";
import { Icon, Stack, StackProps, Text } from '@chakra-ui/react';
import { PrettyPrintJSON } from '@src/components/sco/utilities/PrettyPrintJSON';
import React, { ReactNode } from 'react';
import { LuTriangleAlert } from 'react-icons/lu';
type ErrorStateProps = {
  containerProps?: StackProps;
  error?: Error | any;
  message?: ReactNode;
  children?: ReactNode;
};
export const ErrorState = props => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon asChild={true}><LuTriangleAlert /></Icon>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.message || props.children || "An error occurred.";
  let t2;
  if ($[1] !== t1) {
    t2 = <Text>{t1}</Text>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.error) {
    t3 = process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== "production" && <PrettyPrintJSON data={props.error} />;
    $[3] = props.error;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.containerProps || $[6] !== t2 || $[7] !== t3) {
    t4 = <Stack align="center" justify="center" width="full" {...props.containerProps}>{t0}{t2}{t3}</Stack>;
    $[5] = props.containerProps;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};